/**
 * Broaden a power keyword search without equating rated HP and total HP.
 * Exact equipment filters use separately verified product ratings.
 */
export function normalizePowerQuery(value) {
  return String(value ?? '')
    .replace(/\b(\d+(?:[.,]\d+)?|\d+\s*\/\s*\d+)\s*(?:THP|HP)\b/gi, (_, number) =>
      number.replace(',', '.').replace(/\s/g, '')
    )
    .trim();
}

// Covers the desktop header, search page and mobile search form.
document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || form.getAttribute('role') !== 'search') return;
  const action = new URL(form.action, window.location.origin);
  if (action.origin !== window.location.origin || !/\/search\/?$/.test(action.pathname)) return;
  const input = form.querySelector('input[name="q"]');
  if (input instanceof HTMLInputElement) input.value = normalizePowerQuery(input.value);
}, true);
